import { render, staticRenderFns } from "./AtomMenuUnitEditor.vue?vue&type=template&id=254293d8&scoped=true&lang=pug&"
import script from "./AtomMenuUnitEditor.vue?vue&type=script&lang=js&"
export * from "./AtomMenuUnitEditor.vue?vue&type=script&lang=js&"
import style0 from "./AtomMenuUnitEditor.vue?vue&type=style&index=0&id=254293d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254293d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VList,VMenu})
